import { ActionStatutDTO, UserContact } from 'src/app/shared/models';
import { ToastrService } from 'ngx-toastr';
import { MailDestinataireInput } from 'src/app/shared/models/iCourrier/post/mail-destinataire-input';
import { Component, OnInit, ViewChild } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, FormGroup, FormControl, Validators } from '@angular/forms';
import * as _ from 'underscore';
import * as async from 'async';
import { UserInfo } from 'src/app/shared/models/iCourrier/me/user-info';
import * as moment from 'moment';
import { ConfirmationService } from 'primeng/api';
import { DataService } from 'src/app/shared/services/data.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { TranslateService } from '@devinforius/i-essentials';
import { TreeSelect } from 'primeng/treeselect';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ServicesService } from 'src/app/shared/services/services.service';
import { UsersService } from 'src/app/shared/services/users.service';
import { UserDto } from 'src/app/shared/interfaces/users';
import { map, switchMap } from 'rxjs/operators';
import { ContactsService } from 'src/app/shared/services/contacts.service';
import { ContactDto, DropdownService, GroupsGlobalDto } from 'src/app/shared/interfaces';
import { ActionsService } from 'src/app/shared/services/actions.service';
import { RecipientsService } from 'src/app/shared/services/recipients.service';
import { MeService } from 'src/app/shared/services/me.service';
import { Mail } from 'src/app/shared/models/mails/mail';
import { ServicesPTreeSelect } from 'src/app/shared/models/iCourrier/service';
import { MailDestinataire } from 'src/app/shared/models/mails/mail-destinataire';
import { ConfigDto } from 'src/app/shared/interfaces/config';
import { manageServicesSetAsTreeSelect, manageServicesToBeMerged } from 'src/app/shared/utils/manage-services-for-tree-select.utils';
import { forkJoin, of } from 'rxjs';
import { ConfigService } from 'src/app/shared/services/config.service';
import { ActionTypesDTO } from 'src/app/shared/interfaces/actions/action-types-dto.interface';
import { ITabs } from '@devinforius/i-navigation';
import { GroupsService } from 'src/app/shared/services/groups.service';

@Component({
  selector: 'app-action-create-modal',
  templateUrl: './action-create-modal.component.html',
  styleUrls: ['./action-create-modal.component.scss'],
})
export class ActionCreateModalComponent implements OnInit {
  @ViewChild('treeSelect') treeSelect: TreeSelect;

  public addActionForm = new FormGroup({
    statut: new FormControl(),
    action: new FormControl('', Validators.required),
    transmisDate: new FormControl(),
    echeance: new FormControl(),
    accuseDeReponse: new FormControl(),
    message: new FormControl(),
  });
  public listOfStatus: { label: string; value: string; id: number; ordreAffichage }[] = [];
  public today = new Date();
  public currentMail: Mail;
  public users: UserContact[] = [];
  public userInfos: UserInfo;
  public listOfContacts: { label: string; value: number; id: number; contactId: number; checked: boolean }[] = [];
  public listOfGroups: { label: string; value: number; id: number; checked: boolean }[] = [];
  public actionTypes: { id: number; label: string; value: string }[] = [];
  public configApp: ConfigDto;
  public serviceParent: ServicesPTreeSelect[] = [];
  public servicesFusionned: {
    label: string;
    value: number;
    id: number;
    parentId: number;
    name: string;
    key: string;
    selectable: boolean;
    children: [];
  }[] = [];
  public selectedOption = null;
  public translationPlaceholderPTree = '';

  public listOfChosenUsers: { label: string; value: number; id: number; contactId: number; checked: boolean }[] = [];
  public listOfChosenServices: {
    label: string;
    value: number;
    id: number;
    parentId: number;
    name: string;
    key: string;
    selectable: boolean;
    children: [];
  }[] = [];
  public listOfChosenGroups: { label: string; value: number; id: number; checked: boolean }[] = [];

  public recipientsTabs: ITabs[] = [
    {
      header: 'recipients.users',
      id: 'users',
      active: true,
      count: null,
    },

    {
      header: 'recipients.groups',
      id: 'groups',
      count: null,
    },
    {
      header: 'recipients.services',
      id: 'services',
      count: null,
    },
  ];
  public activeRecipientTab: 'users' | 'groups' | 'services' = 'users';

  public actionForm = new UntypedFormGroup({
    Description: new UntypedFormControl(null),
    EndDate: new UntypedFormControl(null),
    Statut: new UntypedFormControl(null),
    Type: new UntypedFormControl(null),
    ActionDestinataire: new UntypedFormControl(null),
    AccuseReponse: new UntypedFormControl(null),
  });
  constructor(
    private toastr: ToastrService,
    public confirmationService: ConfirmationService,
    public dataService: DataService,
    public spinner: NgxSpinnerService,
    public translater: TranslateService,
    public config: DynamicDialogConfig,
    public ref: DynamicDialogRef,
    private servicesService: ServicesService,
    private usersService: UsersService,
    private contactsService: ContactsService,
    private actionsService: ActionsService,
    private recipientsService: RecipientsService,
    private meService: MeService,
    private configService: ConfigService,
    private groupsService: GroupsService
  ) {}

  ngOnInit(): void {
    this.initializeDatas();
  }

  private initializeDatas(): void {
    if (this.config?.data) {
      this.currentMail = this.config.data.currentCourrier;
      this.translationPlaceholderPTree = this.translater.translate('pleaseSelectAService');
      this.recipientsTabs = this.recipientsTabs.map((tab) => ({ ...tab, header: this.translater.translate(tab.header) }));

      forkJoin({
        services: this.servicesService.fetchMappedServicesToPrimeNGDropdowns(),
        appConfig: this.configService.fetchConfig(),
        userInfos: this.meService.getUserInfo(),
        users: this.usersService.fetchUsersFromiAdmin({ Active: true }).pipe(map((users: UserDto[]) => users.map((el) => new UserContact(el)))),
        types: this.actionsService.getAllActionsTypes(),
        groups: this.groupsService.fetchGlobalGroups(),
      })
        .pipe(
          switchMap((res) => {
            this.manageServicesDatas(res.services);

            this.manageConfigUsersAndContactsDatas(res);

            this.manageActionTypes(res.types);

            this.manageGroups(res.groups);

            return forkJoin({
              status: this.configApp?.mails?.hideStatutAction === false ? this.actionsService.getAllActionsStatutes() : of([]),
            });
          })
        )
        .subscribe((forkJoinResponse: { status: ActionStatutDTO[]; recipients: MailDestinataire[] }) => {
          this.manageActionStatus(forkJoinResponse.status);
        });
    }
  }

  private manageServicesDatas(services: DropdownService[]): void {
    const datasForService = manageServicesSetAsTreeSelect(services, this.translater);
    this.serviceParent = datasForService.servicesForSingleCheck;
    this.servicesFusionned = manageServicesToBeMerged(services);
    this.servicesFusionned = _.sortBy(this.servicesFusionned, 'label');
    this.recipientsTabs.find((tab) => tab.id === 'services').count = this.servicesFusionned.length;
  }

  private manageConfigUsersAndContactsDatas(res: {
    services: DropdownService[];
    appConfig: ConfigDto;
    userInfos: UserInfo;
    users: UserContact[];
    types: ActionTypesDTO[];
  }): void {
    this.configApp = res.appConfig;
    this.userInfos = res.userInfos;
    this.users = res.users;
    this.setContacts();
  }

  private setContacts(): void {
    this.users.forEach((c) => {
      this.listOfContacts.push({
        label: c.name,
        id: c.userId,
        value: c.userId,
        contactId: c.contactForUser.contactId,
        checked: false,
      });
    });

    this.listOfContacts = _.uniq(this.listOfContacts, 'value');
    this.listOfContacts = _.sortBy(this.listOfContacts, 'label');
    this.recipientsTabs.find((tab) => tab.id === 'users').count = this.listOfContacts.length;
  }

  private manageActionTypes(actionTypes: ActionTypesDTO[]): void {
    actionTypes.forEach((type) => {
      this.actionTypes.push({
        id: type.id,
        label: type.description,
        value: type.description,
      });
    });
  }

  private manageGroups(groups: GroupsGlobalDto[]): void {
    groups.forEach((group) => {
      this.listOfGroups.push({
        label: group.description,
        value: group.id,
        id: group.id,
        checked: false,
      });
    });
    this.recipientsTabs.find((tab) => tab.id === 'groups').count = this.listOfGroups.length;
  }

  private manageActionStatus(actionStatus: ActionStatutDTO[]): void {
    actionStatus.forEach((status) => {
      if (status.notUsed === false) {
        this.listOfStatus.push({
          label: status.description,
          value: status.description,
          id: status.id,
          ordreAffichage: status.ordreAffichage,
        });
      }
    });
  }

  /**
   * Display a warning when the selected date is in the past
   * @param event Selected date in the p-calendar
   */
  checkSelectedDate(event): void {
    event.getTime() < this.today.getTime() ? this.toastr.warning('Vous avez sélectionné une date antérieur à celle du jour.', 'Attention !') : '';
  }

  public onActiveTabChange(tabId: 'users' | 'groups' | 'services'): void {
    this.activeRecipientTab = tabId;
  }

  /**
   *
   * @param checkedRecipients has the value of the send infos so it can have the value of this.listOfContacts || this.listOfGroups || this.servicesFusionned
   */
  public onRecipientCheck(checkedRecipients): void {
    switch (this.activeRecipientTab) {
      case 'users':
        this.listOfChosenUsers = checkedRecipients;
        break;
      case 'groups':
        this.listOfChosenGroups = checkedRecipients;
        break;
      case 'services':
        this.listOfChosenServices = checkedRecipients;
        break;
    }
  }

  /**
   * Method called when you create an action
   */
  public submit(): void {
    if (!this.listOfChosenGroups.length && !this.listOfChosenServices.length && !this.listOfChosenUsers.length) {
      this.toastr.warning('action.pleaseChooseARecipient', 'Attention !');
      return;
    }

    if (!this.addActionForm.valid) {
      this.toastr.error('Veuillez remplir les champs obligatoires!');
      return;
    }
    this.spinner.show();

    const destInput = new MailDestinataireInput(this.addActionForm.value);
    destInput.transmisDate = moment(this.today).format();

    if (!this.listOfChosenUsers.length) {
      this.executeAddDestinataire(destInput);
      return;
    }
    this.getReplacingPeopleForContacts(destInput);
  }

  private getReplacingPeopleForContacts(destInput: MailDestinataireInput): void {
    const contactsMappedForQuery = this.listOfChosenUsers.map((user) => {
      return {
        contactIdiAdmin: user.contactId,
        contactUserId: user.value ? user.value : null,
        historiqueDescription: user.label,
      };
    });

    this.contactsService.fetchContactsRemplacantsiCourrier(contactsMappedForQuery.map((contact) => contact.contactIdiAdmin)).subscribe({
      next: (res) => {
        const hasAbsentPeopleArray = [];

        if (res?.length) {
          res.forEach((remplacant) => {
            const foundRecipient = contactsMappedForQuery.find((contact) => contact.contactIdiAdmin === remplacant.contactId);
            if (remplacant.absent === true && foundRecipient) {
              hasAbsentPeopleArray.push(remplacant);
            }
          });
        }

        if (hasAbsentPeopleArray.length > 0) {
          this.spinner.hide();
          this.confirmationService.confirm({
            message: 'Souhaitez-vous remplacer automatiquement les personnes qui sont en congés ?',
            key: 'remplacant',
            accept: () => {
              async.eachSeries(
                hasAbsentPeopleArray,
                (item, next) => {
                  this.contactsService.fetchContact(item.remplaceParContactId, 'iAdmin').subscribe({
                    next: (res: ContactDto) => {
                      if (res) {
                        contactsMappedForQuery.push({
                          contactIdiAdmin: item.remplaceParContactId,
                          contactUserId: null,
                          historiqueDescription: (res.prenom ? res.prenom : '') + ' ' + (res.nom ? res.nom : ''),
                        });
                      }
                      next();
                    },
                  });
                },
                () => {
                  this.executeAddDestinataire(destInput, contactsMappedForQuery);
                }
              );
            },
            reject: () => {
              this.executeAddDestinataire(destInput, contactsMappedForQuery);
            },
          });
        } else {
          this.executeAddDestinataire(destInput, contactsMappedForQuery);
        }
      },
    });
  }

  /**
   * Method execute a api call and close the modal
   * @param dest mailDestinataireInput : data of new destinataire or action
   * @param isAction : boolean , change the final message if it's an action
   */
  public executeAddDestinataire(
    dest: MailDestinataireInput,
    listOfMappedContacts: { contactIdiAdmin: number; contactUserId: number; historiqueDescription: string }[] = []
  ): void {
    const listOfUsers = listOfMappedContacts;
    dest.contacts = listOfUsers;
    dest.serviceIds = this.listOfChosenServices.map((service) => service.id);
    dest.groupeIds = this.listOfChosenGroups.map((group) => group.id);

    this.recipientsService.addMailsDestinataires(this.currentMail.id, dest).subscribe({
      next: () => {
        this.toastr.success("Création de l'action réussie!");
        this.spinner.hide();
        this.ref.close(dest);
      },
      error: (error) => {
        console.error('Error : ', error);
        this.toastr.error("Une erreur s'est produite lors de la création de l'action!");
      },
    });
  }

  /**
   * Basic close modal
   */
  closeActionModal(): void {
    this.ref.close();
  }
}
